// english

export default {
  role_list_title: '角色列表',
  role_btn_add: '添加角色',
  role_btn_auth_menu: '菜单授权',
  role_btn_auth_data: '数据授权',

  // form
  role_form_name: '角色名称',
  role_form_name_placeholder: '请输入角色名称',
  role_form_access_customer: '客户权限',
  role_form_access_site: '站点权限',
  role_form_email: '邮件接口告警',
  role_form_webui_ssh: 'WEB/SSH 权限',
  role_form_webui_ssh_tip1: '下面',
  role_form_webui_ssh_tip2: ' 0：最高级别，1-5：数字越大，权限越小',
  role_form_access_user: '用户权限',
  role_form_access_device: '设备配置权限',
  role_form_read: '读取',
  role_form_write: '写入',
  role_form_download: '下载',
  role_form_access_params: '设备参数权限',
  role_form_access_wiki: '文档权限',
  role_form_access_attach: '附件权限',

  // 权限枚举值
  role_auth: {
    customer: [
      {
        name: '所有客户',
        value: 0,
      },
      {
        name: '仅隶属客户',
        value: 1,
      },
      {
        name: '仅授权的客户',
        value: 2,
      },
    ],
    site: [
      {
        name: '所有站点',
        value: 0,
      },
      {
        name: '仅授权的站点',
        value: 1,
      },
    ],
    webAccess: [
      {
        name: '禁用 WEB和SSH Root',
        value: 0,
      },
      {
        name: '仅 WEB和SSH Root',
        value: 1,
      },
      {
        name: '仅 Web Admin',
        value: 2,
      },
      {
        name: '仅 web Engineer',
        value: 3,
      },
    ],
    // 0-最高级别控制，1~5，5个不同级别控制，数字越大权限越
    levelNumber: [0, 1, 2, 3, 4, 5],
  },

  // conifrm
  role_confirm_delete_title: '确定删除该角色?',
  role_confirm_delete_content: '角色名称: {name}',
};
